import Concept from "../screens/Concept";

export default {
    home:{
        en:'Home',
        tc:'首頁',
        sc:'首页'
    },
    concept:{
        en:'concept',
        tc:'概念',
        sc:'概念',
    },
    sightsee:{
        en:'sightseeing',
        tc:'附近旅游景點',
        sc:'附近旅游景点',
    },
    htgt:{
        en:'how to get there',
        tc:'如何到達第二十一威菲路酒店',
        sc:'如何到达第二十一威菲路酒店',
    },
    rooms:{
        en:'rooms',
        tc:'房間',
        sc:'房间',
    },
    amenity:{
        en:'amenity',
        tc:'酒店設施',
        sc:'酒店设施',
    },
    facility:{
        en:'facility',
        tc:'設施',
        sc:'设施',
    },
    nearBy:{
        en:'nearby facilities',
        tc:'附近設施',
        sc:'附近设施'
    },
    otherInfo:{
        en:'other info',
        tc:'其他資訊',
        sc:'其他资讯'
    },
    lounge:{
        en:'lounge',
        tc:'lounge',
        sc:'lounge',
    },
    artndesign:{
        en:'art and design',
        tc:'art and design',
        sc:'art and design',
    },
    news:{
        en:'news',
        tc:'訊息',
        sc:'讯息',
    },
    nat:{
        en:'news and topics',
        tc:'訊息和話題',
        sc:'讯息和话题'
    },
    reservation:{
        en:'reservation',
        tc:'預訂',
        sc:'预订',
    },
    contact:{
        en:'contact',
        tc:'聯絡我們',
        sc:'联络我们',
    },
    faq:{
        en:'FAQ',
        tc:'常問問題',
        sc:'常问问题'
    },
    pp:{
        en:'privacy-policy',
        tc:'隱私權政策',
        sc:'隐私权政策',
    },
    address:{
        en:'No. 21 Whitfield Road, Causeway Bay, \nHong Kong Island, \nHong Kong.',
        tc:'香港 灣仔區 \n威非路道21號 \n第二十一威菲路酒店',
        sc:'香港 湾仔区 \n威非路道21号 \n第二十一威菲路酒店',
    },
    copyWrite:{
        en:'Copyright © 21 WHITFIELD. All rights reserved.',
        tc:'版權所有 © 21 WHITFIELD。保留所有權利。',
        sc:'版权所有 © 21 WHITFIELD。保留所有权利。',
    },
    lang:{
        en:'Language',
        tc:'語言',
        sc:'语言',
    },
    numOfRooms:{
        en:'Number of rooms',
        tc:'房間數量',
        sc:'房间数量',
    },
    roomText:{
        en:'Room',
        tc:'房間',
        sc:'房间',
    },
    roomsText:{
        en:'Rooms',
        tc:'房間',
        sc:'房间',
    },
    personText:{
        en:'Person',
        tc:'人',
        sc:'人',    
    },
    searchText:{
        en:'Search',
        tc:'搜尋',
        sc:'搜索',
    }
}